module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/pen-6d2cde6a25e5382bd29f895fcee015b4.svg&quot;;"